import { IIndexTypeGroup } from "../model/IndexTypeGroup";
import IndexTypeGroupMapper from "../service/IndexTypeGroupMapper";
import IndexTypeGroupParamMapper from "../service/IndexTypeGroupParamMapper";
import Constants from "../common/Constants";
import FindResourceEntryInteractor from "../../core/interactor/app/crud/FindResourceEntryInteractor";

export default class FindIndexTypeGroupInteractor {
  private resource: FindResourceEntryInteractor<IIndexTypeGroup>;

  constructor({ findResourceEntry }: any) {
    this.resource = findResourceEntry;
  }

  async execute(indexTypeGroupId: number) {
    return this.resource.execute(
      Constants.indexGroupBasePath,
      IndexTypeGroupMapper,
      IndexTypeGroupParamMapper,
      indexTypeGroupId
    );
  }
}
